module.exports = __webpack_public_path__ + "img/ptz-icon4.534527e4.svg";